export const actions = {
  SET_CATEGORIES: "SET_CATEGORIES",
  CREATE_CATEGORY: "CREATE_CATEGORY",
  DELETE_CATEGORY: "DELETE_CATEGORY",
  UPDATE_CATEGORY: "UPDATE_CATEGORY",
};
